import React, { FC } from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { ButtonsWrapper, ContentWrapper, Header } from './styled';
import ButtonBlue from '../../../components/Buttons/ButtonBlue';
import ButtonWhite from '../../../components/Buttons/ButtonWhite';
import useMediaImagesSet from '../../../helpers/useMediaImagesSet';

const Hero: FC<Queries.HeroFragment> = ({ hero }) => {
  const images = useMediaImagesSet(hero?.background);

  return (
    <Header>
      {images && (
        <GatsbyImage
          image={images}
          alt="Background"
          loading="eager"
          style={{
            position: 'absolute',
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
          }}
          imgStyle={{

            objectFit: 'cover',
            objectPosition: 'center top',
          }}
        />
      )}
      <ContentWrapper>
        <h1>{hero?.title}</h1>
        <ButtonsWrapper>
          <ButtonBlue
            href={hero?.links?.main?.url || ''}
            target="_blank"
            rel="noreferrer"
          >
            {hero?.links?.main?.text}
          </ButtonBlue>
          <ButtonWhite
            href={hero?.links?.secondary?.url || ''}
            target="_blank"
            rel="noreferrer"
          >
            {hero?.links?.secondary?.text}
          </ButtonWhite>
        </ButtonsWrapper>
      </ContentWrapper>
    </Header>
  );
};

export const query = graphql`
  fragment Hero on Json {
    hero {
      title
      links {
        main {
          text
          url
        }
        secondary {
          text
          url
        }
      }
      background {
        large {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, quality: 100, placeholder: NONE)
          }
        }
        medium {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, quality: 100, placeholder: NONE)
          }
        }
        small {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, quality: 100, placeholder: NONE)
          }
        }
      }
    }
  }
`;

export default Hero;
